import { PriorityHigh } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export const ExclamationIcon = () => (
    <IconButton>
        <PriorityHigh />
    </IconButton>
);
